/**
 * @description 下拉選單元件，基於 Material Design 的選擇框，提供可自訂的下拉選項清單
 * @class JkComboboxComponent
 * @extends {JkBaseComponent}
 * @implements {OnInit}
 */
import { Component, Input, OnInit, OnChanges, SimpleChanges, output, input, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { FormsModule } from '@angular/forms';

import { idNameItem } from '../../services/jkInterface';
import { jkLib } from '../../services/jkCommon';
/*
export class CustomAlertOptions  {
  header: 'Pizza Toppings';
  subHeader: 'Select your favorite topping';
  message: 'Choose only one';
  translucent: true;
};

export class CustomPopoverOptions {
  header: 'Hair Color';
  subHeader: 'Select your hair color';
  message: 'Only select your dominant hair color';
};

export class CustomActionSheetOptions  {
  header: 'Colors';
  subHeader: 'Select your favorite color';
};
*/
@Component({
  selector: 'app-jkcombobox',
  templateUrl: './jkcombobox.component.html',
  styleUrls: ['./jkcombobox.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MaterialModule,
    FormsModule,
    JkfieldlabelComponent
],
})
export class JkComboboxComponent extends JkBaseComponent implements OnInit, OnChanges {
  override comType: string = 'jkcombobox';
  override flexStyle: any = { display: 'flex' };
  public readonly items = input<idNameItem[]>([]);
  _value: string = '';
  tabIndex: number = 0;
  readonly canSpace = input<boolean>(false); // 可空白不選
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set value(value: string) {
    this._value = value;
  }
  get value() {
    return this._value;
  }
  @Input() set valueInt(value: number) {
    this._value = value.toString();
  }
  get valueInt(): number {
    return Number(this._value) || 0;
  }
  get itemIndex(): number {
    return this.items().findIndex(item => item.id === this._value);
  }
  set itemIndex(value: number) {
    if (value >= 0 && value < this.items().length)
      this._value = this.items()[value].id;
    else
      this._value = '';
  }
  /*_valueN: number = 0;
  @Input()
  set valueN(value:number){// 有在用 不要再刪
    this._valueN = value; // = jkLib.fixString(value);
    if(this._valueN === null || this._valueN === undefined)
      this._value = '';
    else
      this._value = this._valueN.toString();
  }
  get valueN(): number{
    if(this._value === '' || this._value === null)
      return 0
    else
      return Number(this._value);
    //return this._valueN;
  }*/
  readonly valueChange = output<string>();
  readonly valueIntChange = output<number>();
  //@Output() valueNChange = new EventEmitter<number>();
  onValueChange(newValue: string) {
    // debugger;
    /* if(this.value !== newValue) FIXME: 有時候 會不斷 loop
      this.value = newValue; */
    if (this.valueChange)
      this.valueChange.emit(newValue);
    this.valueIntChange.emit(Number(newValue) || 0);
  }
  // onValueNChange(newValue: number) {
  //   // debugger;
  //   /*if(this.value !== newValue)
  //     this.value = newValue;*/
  //   if(this.valueNChange)
  //     this.valueNChange.emit(newValue);
  // }
  //name: string = '';
  constructor() {
    super();
  }
  /*public set items(x: JkComboboxData[]){
    x.forEach(item => this.myItems.push(item));
    console.log('combox get:',x.length);
  }*/

  override ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      if (!Array.isArray(changes['items'].currentValue)) {
        console.debug('JkComboboxComponent: items is not an array!', changes['items'].currentValue);
      }
    }
  }
  /*
  handleChange(event: any) {
    //console.log('handleChange:', event.detail.value);
    this.value = event.detail.value;
  }
  onChanged(e) {
    this.value = e;
    this.ref.detectChanges();
  }*/
  addWhere(where: string, fieldName: string, condition: string = '='): string {
    if (this.value) {
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }

}
